define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "../../atoms/Typography", "styled-components", "../../themes"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _Typography, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.ModalTitle = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var _excluded = ["title", "labelId", "isTitleVisuallyHidden"];
  var Title = (0, _styledComponents.default)(_Typography.H1).withConfig({
    displayName: "ModalTitle__Title",
    componentId: "sc-67p8vc-0"
  })(["font-weight:", ";line-height:1.33;margin:0 0 16px;padding:0 16px 0 0;", ""], function (_ref) {
    var theme = _ref.theme;
    return theme.font.regular;
  }, function (_ref2) {
    var isHidden = _ref2.isHidden;
    return isHidden && (0, _styledComponents.css)(["", ""], _themes.visuallyHidden);
  });

  var ModalTitle = function ModalTitle(_ref3) {
    var title = _ref3.title,
        labelId = _ref3.labelId,
        isTitleVisuallyHidden = _ref3.isTitleVisuallyHidden,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref3, _excluded);
    return /*#__PURE__*/_react.default.createElement(Title, (0, _extends2.default)({}, props, {
      id: labelId,
      isHidden: isTitleVisuallyHidden
    }), title);
  };

  _exports.ModalTitle = ModalTitle;
  var _default = ModalTitle;
  _exports.default = _default;
});